import type { Hit } from "instantsearch.js";
import { unescape as unescapeHtml } from "instantsearch.js/es/lib/utils/escape-html";
import { getHighlightedParts } from "instantsearch.js/es/lib/utils/getHighlightedParts";
import type { SearchIndexHit } from "./types";

export function getExcerptParts(hit: Hit<SearchIndexHit>) {
	const snippet = hit._snippetResult?.content;
	const value =
		snippet && !Array.isArray(snippet) && typeof snippet.value === "string"
			? snippet.value
			: undefined;
	const parts =
		value === undefined
			? [{ value: hit.content ?? "", isHighlighted: false }]
			: getHighlightedParts(value).map((part) => ({
					...part,
					value: unescapeHtml(part.value),
				}));
	const text = parts.map((part) => part.value).join("");
	const title = hit.title
		.trim()
		.split(/\s+/)
		.map((word) => word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))
		.join("\\s+");
	const duplicate = title
		? text.match(new RegExp(`^\\s*${title}(?=\\s|$)\\s*`, "i"))
		: null;
	let skip = duplicate?.[0].length ?? 0;
	const excerpt = parts.flatMap((part) => {
		const value = part.value.slice(skip);
		skip = Math.max(0, skip - part.value.length);
		return value ? [{ ...part, value }] : [];
	});
	if (excerpt.length > 0 && hit.content && text.length < hit.content.length) {
		if (!hit.content.startsWith(text))
			excerpt[0].value = `…${excerpt[0].value}`;
		excerpt[excerpt.length - 1].value += "…";
	}
	return excerpt;
}
